import React, { useState, useRef, useEffect } from 'react';
import './RSVPList.css';
import { FaAngleDown } from "react-icons/fa6";
import { FaAngleUp } from "react-icons/fa6";
import { IoClose } from "react-icons/io5";

export default function RSVPList() {
    const [isRSVPopen, setIsRSVPopen] = useState(false);
    const dropdownRef = useRef(null);

    const toggleRSVP = () => {
        setIsRSVPopen(prev => !prev);
    };

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsRSVPopen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const users = [
        { name: "Ravinder Garg", gender: "Male", rsvp: "Yes" },
        { name: "Sima", gender: "Female", rsvp: "No" },
        { name: "Name", gender: "Gender", rsvp: "Yes" },
        { name: "Name", gender: "Gender", rsvp: "Yes" },
        { name: "Name", gender: "Gender", rsvp: "Yes" },
        { name: "Name", gender: "Gender", rsvp: "Yes" },
    ];

    return (
        <div className="rsvp-wrapper" ref={dropdownRef}>
            <div className="rsvp-trigger" onClick={toggleRSVP}>
                Check RSVP {isRSVPopen ? <FaAngleUp /> : <FaAngleDown />}
            </div>

            {isRSVPopen && (
                <div className="rsvp-modal">
                    <div className='rsvp-modal-container'>
                        <div className='rsvp-modal-content'>
                        <div className='rsvp-modal-content-close' onClick={toggleRSVP}><IoClose color="red" /></div>
                       
                        <div className="rsvp-sub-header">
                            <span>Name</span>
                            <span>Gender</span>
                            <span>RSVP</span>
                        </div>

                        {users.map((user, index) => (
                            <div className="rsvp-row" key={index}>
                                <div className="user-avatar"></div>
                                <div className="rsvp-user">
                                    <span className='rsvp-user-text'>{user.name}</span>
                                </div>
                                <span className='rsvp-user-text'>{user.gender}</span>
                                <span className='rsvp-user-text'>{user.rsvp}</span>
                            </div>
                        ))}
                         </div>
                    </div>
                </div>
            )}
        </div>
    );
}
